import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const TrainingListPage = () =>
  import('@modules/training/components/training-list-page.vue');
const TrainingFormPage = () =>
  import('@modules/training/components/training-form-page.vue');
const TrainingViewPage = () =>
  import('@modules/training/components/training-view-page.vue');
const TrainingImporterPage = () =>
  import('@modules/training/components/training-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'training',
        path: '/training',
        component: TrainingListPage,
        meta: {
          auth: true,
          permission: Permissions.values.trainingView,
        },
      },
      {
        name: 'trainingNew',
        path: '/training/new',
        component: TrainingFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.trainingCreate,
        },
      },
      {
        name: 'trainingImporter',
        path: '/training/import',
        component: TrainingImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.trainingImport,
        },
      },
      {
        name: 'trainingEdit',
        path: '/training/:id/edit',
        component: TrainingFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.trainingEdit,
        },
        props: true,
      },
      {
        name: 'trainingView',
        path: '/training/:id',
        component: TrainingViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.trainingView,
        },
        props: true,
      },
    ],
  },
];
